/**
 *
 * EmptyStateScreen
 *
 */

import React from "react"
// import PropTypes from 'prop-types';

import "./index.less"
import DOMPurify from "dompurify"

function EmptyStateScreen(props) {
  const sanitizedHTML = DOMPurify.sanitize(props.description);

  return (
    <div className="empty-state-screen">
      <img src={props.image} width={340} />
      <div className="empty-state-screen-description">
        <span className="empty-state-screen-description-title">
          {props.title}
        </span>
        <p dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
        <p className="empty-state-screen-remember">
          <span>¡Recuerda!</span> {props.remember}
        </p>
      </div>
      {props.children}
    </div>
  )
}

EmptyStateScreen.propTypes = {}

export default EmptyStateScreen
